var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.19 1.5H7.81C5.89056 1.5 4.29882 2.07407 3.18645 3.18645C2.07407 4.29882 1.5 5.89056 1.5 7.81V16.18C1.5 18.1041 2.07386 19.6983 3.18623 20.8121C4.29866 21.9259 5.89055 22.5 7.81 22.5H16.18C18.0994 22.5 19.6912 21.9259 20.8036 20.8136C21.9159 19.7012 22.49 18.1094 22.49 16.19L22.49 7.81137C22.49 7.81114 22.49 7.8109 22.49 7.81067C22.4951 5.89123 21.9237 4.29927 20.8125 3.18667C19.7013 2.07403 18.1093 1.5 16.19 1.5ZM17 16.75H7C6.86614 16.75 6.75 16.6339 6.75 16.5C6.75 16.3661 6.86614 16.25 7 16.25H17C17.1339 16.25 17.25 16.3661 17.25 16.5C17.25 16.6339 17.1339 16.75 17 16.75ZM17 12.25H7C6.86614 12.25 6.75 12.1339 6.75 12C6.75 11.8661 6.86614 11.75 7 11.75H17C17.1339 11.75 17.25 11.8661 17.25 12C17.25 12.1339 17.1339 12.25 17 12.25ZM17 7.75H7C6.86614 7.75 6.75 7.63386 6.75 7.5C6.75 7.36614 6.86614 7.25 7 7.25H17C17.1339 7.25 17.25 7.36614 17.25 7.5C17.25 7.63386 17.1339 7.75 17 7.75Z",
    fill: "#FAFBFC",
    stroke: "#ECF0F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.5H17",
    stroke: "#9CA8BA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12H17",
    stroke: "#9CA8BA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16.5H17",
    stroke: "#9CA8BA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.cd91cc5f994adf5c63cbfc67dd173c3d.svg";
export { ForwardRef as ReactComponent };